<template>
  <div class="slider-group">
    <base-checkbox
      v-model="toReplace"
      :disabled="disabled"
      @input="toReplaceChecked"
    >
      {{ $t("INSPECTIONS.TO_REPLACE") }}
    </base-checkbox>
    <div class="modal-radio-group">
      <h5>
        {{ $t("INSPECTIONS.TIRE_TYPE") }}
      </h5>
      <div
        class="radio-group"
        v-for="type in types"
        :key="`type_${type}_${refKey}`"
      >
        <div class="btn-group-item">
          <input
            type="radio"
            class="btn-check"
            :id="`type_${type}_${refKey}`"
            :name="`type_${type}_${refKey}`"
            :disabled="disabled"
            :value="type"
            v-model="fieldValue.type"
          />
          <label
            class="btn btn-outline-primary"
            :for="`type_${type}_${refKey}`"
          >
            {{ $t(`INSPECTIONS.${type}`) }}
            <span class="check">
              <i class="far fa-check"></i>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="modal-radio-group">
      <h5>
        {{ $t("INSPECTIONS.TIRE_SEASON") }}
      </h5>
      <div
        class="radio-group"
        v-for="season in seasons"
        :key="`season_${season}_${refKey}`"
      >
        <div class="btn-group-item">
          <input
            type="radio"
            class="btn-check"
            :id="`season_${season}_${refKey}`"
            :name="`season_${season}_${refKey}`"
            :disabled="disabled"
            :value="season"
            v-model="fieldValue.season"
          />
          <label
            class="btn btn-outline-primary"
            :for="`season_${season}_${refKey}`"
          >
            {{ $t(`INSPECTIONS.${season}`) }}
            <span class="check">
              <i class="far fa-check"></i>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="slider-icon" :class="iconClass">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32.297"
        height="32.297"
        viewBox="0 0 32.297 32.297"
      >
        <g
          id="Groupe_3199"
          data-name="Groupe 3199"
          transform="translate(-8.85 -8.852)"
        >
          <path
            id="Tracé_2020"
            data-name="Tracé 2020"
            d="M17.1,6.453h0c-.168,0-.333.007-.5.018-.09,0-.181.011-.271.018l-.128.013c-.095.009-.192.018-.287.031-.066.007-.13.015-.2.026a.559.559,0,0,0-.064.009l-.15.022-.148.026c-.035,0-.071.011-.106.018a11.485,11.485,0,0,0-1.142.278l-.132.042a10.787,10.787,0,0,0-1.367.538l-.062.029A10.788,10.788,0,0,0,6.5,16.195c0,.042-.009.086-.011.128-.011.128-.02.258-.026.388,0,.086-.007.172-.009.258s0,.172,0,.258a10.766,10.766,0,0,0,.062,1.162c.033.3.077.6.134.9a10.339,10.339,0,0,0,.324,1.259c.053.165.11.331.172.494.031.082.062.163.095.245.066.161.137.322.209.483a10.86,10.86,0,0,0,4.075,4.606c.075.049.152.095.227.139q.4.238.82.437c.079.04.159.075.238.112a10.8,10.8,0,0,0,2.743.814c.084.013.17.024.256.035l.128.018c.086.009.172.02.258.026l.128.013A10.775,10.775,0,1,0,17.1,6.453m-4.355,3.956.026-.018c.022-.015.044-.029.066-.042l.033-.022c.02-.011.037-.024.057-.037l.037-.022.057-.033.035-.022.06-.035.035-.02a.561.561,0,0,1,.062-.035l.031-.02c.024-.013.049-.026.073-.037l.022-.013c.033-.018.064-.035.1-.051l.009-.007c.029-.013.057-.029.086-.044l.029-.013c.022-.013.046-.024.068-.035l.033-.015.064-.031.035-.018a.528.528,0,0,0,.062-.029l.037-.015.064-.029.033-.015.071-.031.029-.011.093-.04h0l.106-.042.013,0,.086-.033.026-.011.073-.026.033-.011.068-.024.033-.011.071-.024.031-.011.075-.022.026-.009.086-.026.015,0q.106-.033.212-.06l.011,0c.031-.007.062-.015.09-.024l.024,0,.079-.02.029-.007c.026-.007.051-.013.077-.018l.029-.007.079-.018.024,0c.029-.007.057-.013.088-.018l.015,0c.108-.02.214-.04.322-.055l.009,0c.033,0,.064-.009.1-.015l.018,0,.088-.011.022,0,.086-.011.02,0c.031,0,.062-.007.093-.009l.015,0c.143-.015.289-.024.434-.031h0c.035,0,.068,0,.1,0h.011c.033,0,.064,0,.1,0l.013,0H17.3c.183,0,.366.009.549.024h.007c.035,0,.068,0,.1.009h.009c.035,0,.071.007.1.011h0c.218.022.437.055.655.095h0l.106.02,0,0c.216.044.432.095.646.157l-2.672,5.248-4.163-4.165.09-.06m7.137,6.745a.487.487,0,1,1-.556.406.488.488,0,0,1,.556-.406m-4.844-1.429a.486.486,0,1,1,.688,0,.487.487,0,0,1-.688,0m.086,3.12a.487.487,0,1,1,.212-.655.488.488,0,0,1-.212.655m-5.735.644h0q-.093-.321-.159-.648l-.02-.108,0,0c-.04-.218-.071-.437-.095-.657v0L9.1,17.965v-.007l-.009-.1V17.85c-.013-.183-.022-.368-.024-.551v-.117l0-.1v-.013l0-.1v-.013l0-.1v0c.007-.146.018-.291.031-.437l0-.013.009-.093,0-.02c0-.029.009-.057.011-.088l0-.02.013-.088,0-.018.013-.1,0-.007c.015-.108.035-.216.055-.322l0-.018.018-.086,0-.026c.007-.026.013-.053.018-.079l.007-.026.018-.079.007-.026.02-.079.007-.024c.007-.031.015-.062.024-.09l0-.013.06-.209,0-.015.026-.086.009-.029c.007-.024.015-.049.024-.073l.009-.031.024-.071.011-.033c.009-.024.018-.046.024-.071l.011-.031.026-.073.011-.029.033-.086,0-.013c.015-.033.029-.068.042-.1l0,0c.013-.033.024-.064.037-.095l.013-.026a.681.681,0,0,1,.031-.071l.013-.035a.562.562,0,0,0,.029-.064l.018-.035c.009-.02.018-.042.029-.062l.018-.037.029-.062.018-.035.033-.066.015-.029c.013-.029.029-.057.044-.086l0-.011c.018-.031.033-.064.051-.095l.013-.022.04-.073.018-.033.035-.062.022-.035.033-.057.022-.037.035-.057.022-.035.037-.06.02-.033.042-.064.018-.026c.02-.031.04-.062.062-.093l4.163,4.165Zm7.567,5.891c-.029,0-.06,0-.088,0h-.007c-.029,0-.057,0-.084,0h-.011l-.082,0-.013,0c-.026,0-.053,0-.079,0l-.015,0-.079-.007H16.48l-.077-.009-.018,0-.077-.007-.015,0-.077-.009-.018,0-.077-.011-.015,0c-.026,0-.053-.007-.079-.011l-.013,0c-.026,0-.053-.009-.079-.011l-.013,0c-.026,0-.053-.009-.082-.015h-.009l-.084-.015h0a8.074,8.074,0,0,1-.814-.194l-.009,0-.075-.024-.018,0L14.756,25,14.734,25l-.066-.022-.024-.009-.066-.02-.026-.011c-.02-.007-.042-.013-.062-.022L14.46,24.9l-.062-.022-.031-.011-.06-.024-.031-.011-.057-.022-.033-.013-.057-.024-.031-.013a.448.448,0,0,1-.057-.024l-.033-.013-.055-.024-.033-.013-.057-.026-.031-.013-.057-.026-.031-.015-.055-.026-.033-.015-.055-.026-.031-.015a.464.464,0,0,0-.057-.029l-.026-.015-.06-.031-.02-.011c-.077-.04-.15-.079-.225-.123l-.011,0-.053-.031-.031-.02-.049-.029L13,24.207l-.046-.029-.037-.022-.044-.029-.04-.024-.044-.029-.04-.026-.042-.029-.042-.026-.042-.029-.04-.029-.042-.029-.04-.029-.04-.029-.042-.029-.04-.031-.042-.029-.04-.031-.04-.031-.04-.031-.04-.031-.04-.031-.04-.033-.037-.031-.042-.033-.037-.031-.04-.035-.037-.031-.042-.035-.033-.031-.044-.037-.033-.031-.044-.04-.031-.029-.046-.044L11.6,23.14l-.051-.049-.024-.024-.073-.073c-.029-.026-.055-.055-.084-.084l-.024-.024-.057-.062-.026-.029-.06-.064-.02-.022c-.024-.026-.049-.053-.073-.082l0,0c-.055-.062-.11-.126-.163-.19l0,0-.075-.093,0-.007c-.026-.031-.051-.062-.075-.095l5.245-2.672Zm.756-5.1a.486.486,0,1,1,.4-.556.486.486,0,0,1-.4.556M18.3,18.3a1.513,1.513,0,1,1,0-2.139,1.514,1.514,0,0,1,0,2.139m.547-3.175a.486.486,0,1,1-.212-.653.482.482,0,0,1,.212.653M24.9,20c-.049.134-.1.269-.157.4l-.007.013L24.7,20.5l-.009.02-.035.077-.009.022-.035.075-.011.024c-.011.024-.024.049-.035.075l-.011.022-.037.075-.011.02L24.464,21l-.007.011c-.051.1-.1.192-.157.287l-.007.011-.049.082-.013.022c-.013.022-.026.046-.042.068l-.015.026-.04.064-.02.031-.037.06-.02.031-.04.06L24,21.78l-.04.06-.02.031-.044.062-.02.026c-.015.024-.033.046-.051.071l-.011.018-.132.174-.018.022-.049.062-.026.031-.042.055-.029.033-.042.051-.029.033-.042.049-.031.035c-.013.018-.029.033-.042.049l-.031.035-.044.046-.031.035-.046.049-.029.031a.6.6,0,0,0-.051.055l-.026.026c-.026.024-.051.051-.077.077l0,0-.077.077-.026.024-.053.051-.033.031-.049.046-.033.031-.049.042-.035.031-.046.044-.035.029c-.015.015-.033.029-.049.042l-.035.031-.051.042-.033.026-.053.044-.031.024-.062.049-.024.02c-.057.044-.115.088-.174.13l-.018.013c-.022.018-.046.033-.071.051l-.026.018a.625.625,0,0,1-.062.044l-.029.02L21.78,24l-.031.02-.06.04-.031.02-.062.04-.029.018a.729.729,0,0,1-.064.04l-.029.018-.068.042-.022.013c-.026.015-.055.031-.082.049l-.011,0c-.095.055-.19.108-.287.159l-.011,0c-.026.015-.055.029-.084.044l-.018.009c-.026.013-.051.026-.077.037l-.022.011-.075.037-.022.009c-.024.013-.051.024-.075.035l-.022.011a.822.822,0,0,0-.077.035l-.02.007-.084.037-.013,0c-.134.057-.267.11-.4.159l-.922-5.816Zm-.029-5.636.011.031.022.06.011.029.022.064.009.026.022.064.009.024.02.068.009.022.022.071,0,.015.022.075,0,.011a8.032,8.032,0,0,1,.194.811v0c.007.029.011.057.015.086l0,.009.013.082,0,.011c0,.026.009.053.011.079l0,.015.013.079,0,.015.009.077,0,.015c0,.026.007.053.009.077l0,.018.009.077,0,.015.007.079,0,.015.007.079v.013l.007.082v.011l.007.084v.009l0,.086v.007l0,.088-5.814-.922,2.675-5.245c.031.024.062.051.095.075l.007.007.09.075,0,0c.062.053.126.106.187.161l.007,0c.026.024.053.049.082.073l.022.022.064.06.026.024.062.06.024.024.086.082v0l.073.073.022.024a.528.528,0,0,1,.049.051l.029.029.042.044.029.033.04.044.031.033.037.042.031.035.035.042.031.035.035.042.031.037.035.04.029.037.033.042.031.037.033.042.029.037.033.042.029.04.031.04.029.042.031.04.029.04.029.042.029.042.029.04.026.042.029.04.026.044.026.04.029.042.024.04.029.046.024.037.029.046.022.035.029.049.018.033.031.053.007.011c.042.073.084.148.123.223l.011.022.031.057.013.029.029.057.015.029.026.057.015.031.026.055.015.033.026.055.015.033.024.055.015.033c.007.02.015.037.024.057l.013.033.024.055.013.033.022.057.013.031.022.06.013.031.022.06"
            transform="translate(7.773 7.774)"
            fill="#07bc00"
          />
          <path
            id="Tracé_2021"
            data-name="Tracé 2021"
            d="M36.011,18.391h-.333c-.02-.176-.044-.353-.071-.531l.322-.084a.3.3,0,0,0,.214-.37l-.763-2.842a.3.3,0,0,0-.368-.214l-.318.086q-.1-.248-.205-.5l.284-.163a.3.3,0,0,0,.11-.412l-1.471-2.549A.3.3,0,0,0,33,10.7l-.287.165c-.106-.143-.216-.284-.326-.423l.234-.236a.3.3,0,0,0,0-.426L30.541,7.7a.3.3,0,0,0-.426,0l-.234.236c-.141-.112-.282-.22-.426-.326l.165-.287a.3.3,0,0,0-.11-.412L26.962,5.444a.3.3,0,0,0-.41.11l-.165.284q-.245-.109-.5-.205l.086-.318a.3.3,0,0,0-.214-.37l-2.842-.761a.3.3,0,0,0-.368.214l-.086.32c-.176-.026-.353-.051-.531-.071V4.317a.3.3,0,0,0-.3-.3H18.692a.3.3,0,0,0-.3.3v.331c-.176.02-.353.044-.531.071l-.084-.32a.3.3,0,0,0-.37-.214l-2.842.761a.3.3,0,0,0-.214.37l.086.318q-.248.1-.5.205l-.163-.284a.3.3,0,0,0-.412-.11L10.814,6.914a.3.3,0,0,0-.11.412l.165.287c-.143.106-.284.214-.423.326L10.21,7.7a.3.3,0,0,0-.426,0L7.7,9.785a.3.3,0,0,0,0,.426l.236.236c-.112.139-.22.28-.326.423L7.326,10.7a.3.3,0,0,0-.412.11L5.443,13.364a.3.3,0,0,0,.11.412l.284.163q-.109.248-.205.5l-.318-.086a.3.3,0,0,0-.37.214l-.761,2.842a.3.3,0,0,0,.214.37l.32.084c-.026.179-.051.355-.071.531H4.316a.3.3,0,0,0-.3.3v2.941a.3.3,0,0,0,.3.3h.331c.02.179.044.355.071.531l-.32.086a.3.3,0,0,0-.214.368l.761,2.842a.3.3,0,0,0,.37.214l.318-.086q.1.251.205.5l-.284.165a.3.3,0,0,0-.11.41l1.471,2.549a.3.3,0,0,0,.412.11l.287-.165c.106.143.214.284.326.426l-.236.234a.3.3,0,0,0,0,.426l2.081,2.081a.3.3,0,0,0,.426,0l.236-.234c.139.11.28.22.423.326L10.7,33a.3.3,0,0,0,.11.412l2.549,1.471a.3.3,0,0,0,.412-.11l.163-.284q.248.106.5.205l-.086.318a.3.3,0,0,0,.214.368l2.842.763a.3.3,0,0,0,.37-.214l.084-.322c.179.026.355.051.531.071v.333a.3.3,0,0,0,.3.3h2.941a.3.3,0,0,0,.3-.3v-.333c.179-.02.355-.044.531-.071l.086.322a.3.3,0,0,0,.368.214l2.842-.763a.3.3,0,0,0,.214-.368l-.086-.318q.251-.1.5-.205l.165.284a.3.3,0,0,0,.41.11l2.549-1.471a.3.3,0,0,0,.11-.412l-.165-.287c.143-.106.284-.216.426-.326l.234.234a.3.3,0,0,0,.426,0l2.081-2.081a.3.3,0,0,0,0-.426l-.234-.234c.11-.141.22-.282.326-.426l.287.165a.3.3,0,0,0,.412-.11l1.471-2.549a.3.3,0,0,0-.11-.41l-.284-.165q.106-.245.205-.5l.318.086a.3.3,0,0,0,.368-.214l.763-2.842a.3.3,0,0,0-.214-.368l-.322-.086c.026-.176.051-.353.071-.531h.333a.3.3,0,0,0,.3-.3V18.693a.3.3,0,0,0-.3-.3M28.523,28.524a11.824,11.824,0,1,1,0-16.722,11.825,11.825,0,0,1,0,16.722"
            transform="translate(4.836 4.837)"
            fill="#07bc00"
          />
        </g>
      </svg>
    </div>
    <base-slider
      v-model="fieldValue.ratio"
      :range="{ min: 0, max: max_value }"
      :options="{ step: 1 }"
      :disabled="!fieldValue.type || !fieldValue.season || disabled"
    ></base-slider>
    <span class="range-slider-value">
      {{ Math.round(fieldValue.ratio) }} / 32"
    </span>

    <action-comment-widget
      :showActionModal="showActionModal"
      :disabled="disabled"
      :actionValue="defaultActionValue"
      :fieldValue="fieldValue.value"
      :commentValue="commentValue"
      @actionCanceled="cancelAction"
      @actionChanged="changeAction"
    />
  </div>
</template>

<script>
import { cloneDeep, isEqual, debounce } from "lodash";
import { Button } from "element-ui";
import { uniqueId } from "lodash";
import { BaseSlider } from "@/components";
import {
  INSPECTION_ACTION_NO_ACTION,
  INSPECTION_ACTION_TO_REPLACE,
  INSPECTION_ACTION_TO_VERIFY,
} from "@/constants/inspections";
import ActionCommentWidget from "./ActionCommentWidget.vue";

export default {
  name: "tire-state-field-widget",

  components: {
    [Button.name]: Button,
    BaseSlider,
    ActionCommentWidget,
  },

  props: [
    "fieldForm",
    "defaultValue",
    "disabled",
    "defaultActionValue",
    "commentValue",
    "touched",
  ],

  data() {
    const refKey = uniqueId([]);
    const value = this.getFormattedValue();
    let maxValue = 11;
    if (value.type == "OFF_ROAD") {
      maxValue = 16;
    }
    return {
      refKey,
      fieldValue: value,
      types: ["STANDARD", "OFF_ROAD", "SUPER_SPORT"],
      seasons: ["SUMMER", "WINTER", "FOUR_SEASONS"],
      max_value: maxValue,
      warning_threshold: 4,
      good_threshold: 7,
      toReplace: this.defaultActionValue == INSPECTION_ACTION_TO_REPLACE,
      showActionModal: false,
    };
  },

  computed: {
    iconClass() {
      if (this.fieldValue.value === "GOOD") {
        return "icon-good";
      } else if (this.fieldValue.value === "WARNING") {
        return "icon-warning";
      } else {
        return "icon-bad";
      }
    },
  },

  created() {},

  methods: {
    getFormattedValue() {
      let value = cloneDeep(this.defaultValue);
      if (!value) {
        value = {
          value: "BAD",
          ratio: 0,
          type: null,
          season: null,
        };
        this.$emit("change", value);
      }
      return { ...value };
    },

    changeAction(action, comment) {
      this.showActionModal = false;
      this.$emit("change", this.fieldValue);
      this.$emit("actionChanged", action, comment);
    },

    cancelAction() {
      this.updateValue();
      this.showActionModal = false;
    },

    updateValueDebounced: debounce(function () {
      this.updateValue();
    }, 500),

    setMinMaxValues() {
      if (this.fieldValue.type == "OFF_ROAD") {
        this.max_value = 16;
        this.warning_threshold = 6;
        this.good_threshold = 9;
      } else if (this.fieldValue.type == "SUPER_SPORT") {
        this.max_value = 11;
        this.warning_threshold = 3;
        this.good_threshold = 5;
      } else if (this.fieldValue.type == "STANDARD") {
        this.max_value = 11;
        this.warning_threshold = 4;
        this.good_threshold = 7;
      }
    },

    updateValue() {
      this.setMinMaxValues();

      if (this.fieldValue.ratio > this.max_value) {
        this.fieldValue.ratio = this.max_value;
      }

      if (this.fieldValue.ratio >= this.good_threshold) {
        this.fieldValue.value = "GOOD";
      } else if (this.fieldValue.ratio >= this.warning_threshold) {
        this.fieldValue.value = "WARNING";
      } else {
        this.fieldValue.value = "BAD";
      }

      if (this.fieldValue.value == "GOOD") {
        this.toReplace = false;
        this.$emit("actionChanged", INSPECTION_ACTION_NO_ACTION);
      } else if (this.fieldValue.value == "WARNING") {
        this.toReplace = false;
        this.$emit("actionChanged", INSPECTION_ACTION_TO_VERIFY);
      } else if (this.fieldValue.value == "BAD") {
        if (this.touched) {
          this.toReplace = true;
        }
        this.$emit("actionChanged", INSPECTION_ACTION_TO_REPLACE);
      }
      this.$emit("change", this.fieldValue);
    },

    toReplaceChecked(value) {
      if (value) {
        this.showActionModal = true;
        this.$emit("actionChanged", INSPECTION_ACTION_TO_REPLACE);
      } else {
        this.$emit("actionChanged", INSPECTION_ACTION_NO_ACTION);
      }
    },
  },

  mounted() {},

  watch: {
    defaultValue() {
      this.fieldValue = this.getFormattedValue();
      this.setMinMaxValues();
    },
    defaultActionValue() {
      this.toReplace = this.defaultActionValue == INSPECTION_ACTION_TO_REPLACE;
    },
    fieldValue: {
      handler: function () {
        if (!isEqual(this.fieldValue, this.defaultValue)) {
          this.updateValueDebounced();
        }
      },
      deep: true,
      immediate: false,
    },
  },
};
</script>
